import AuthContext, {
    IAuthContextInterface,
} from "@callveriq/contexts/AuthContext";
import { useContext } from "react";

const useAuth = (): IAuthContextInterface => {
    const context = useContext(AuthContext);

    if (!context)
        throw new Error("Auth context must be use inside AuthProvider");

    return context;
};

export default useAuth;
